import React from 'react';

export default function WebMasterLink() {
  return (
    <div
        style={{position: 'fixed', top: '8px', right: '20px', zIndex: '5000'}}>
        <a
          className="webmasterLink"
          href="https://www.pascalcosta.fr/#/contact"
          target="_blank"
          rel="noreferrer">Contact the webmaster</a>
    </div>
  )
}
